import { memo } from 'react';
import { Color, PieceType } from '@draughts/shared';
import Piece from '../game/Piece';
import type { ColorPair } from '../game/piece-themes';
import type { PieceLod } from '../game/piece-lod';

interface PieceSwatchProps {
  color: 'white' | 'black';
  king?: boolean;
  /** Lato del quadrato in px. Il pezzo occupa l'85% del lato. */
  size?: number;
  /** Colori risolti; se omessi il <Piece> ricade sul tema `classic`. */
  colorPair?: ColorPair;
  className?: string;
  /** Forza un tier; default 'micro', quello giusto per un'icona di pochi px. */
  lod?: PieceLod;
}

/**
 * Pezzo in miniatura autonomo: un `<svg>` con i propri `<defs>`, usabile ovunque
 * serva un indicatore del colore del giocatore (avatar, righe dello storico,
 * intestazioni del replay).
 *
 * Esiste per non riscrivere a mano un cerchio piatto in ogni punto dell'app: così
 * forma, stile 3D e marcatura della dama seguono le preferenze anche qui.
 *
 * Il viewBox riserva margine SOTTO il pezzo per l'estrusione della parete degli
 * stili 3D (fino a 0.22·radius), che altrimenti verrebbe tagliata.
 */
export default memo(function PieceSwatch({
  color,
  king = false,
  size = 16,
  colorPair,
  className,
  lod = 'micro',
}: PieceSwatchProps) {
  const pieceSize = size * 0.85;
  const headroom = pieceSize * 0.14;
  const height = size + headroom;

  return (
    <svg
      className={className}
      width={size}
      height={height}
      viewBox={`0 0 ${size} ${height}`}
      aria-hidden="true"
      focusable="false"
    >
      <Piece
        piece={{
          color: color === 'white' ? Color.WHITE : Color.BLACK,
          type: king ? PieceType.KING : PieceType.MAN,
          square: 0,
        }}
        x={size / 2}
        y={size / 2}
        size={pieceSize}
        colorPair={colorPair}
        lod={lod}
      />
    </svg>
  );
});
